export interface GenerateNameOptions {
  includeBare?: boolean;
}

export function generateNextAvailableName(
  base: string,
  existingNames: string[],
  { includeBare = false }: GenerateNameOptions = {}
): string {
  const existing = new Set(existingNames.map(n => n.toLowerCase()));
  if (includeBare && !existing.has(base.toLowerCase())) return base;
  let counter = 1;
  let name = `${base} ${counter}`;
  while (existing.has(name.toLowerCase())) name = `${base} ${++counter}`;
  return name;
}
